import { render, staticRenderFns } from "./CompanyAddresses.vue?vue&type=template&id=fab9c724"
import script from "./CompanyAddresses.vue?vue&type=script&lang=js"
export * from "./CompanyAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports